import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

@Component({
  selector: 'app-copy-cropfields-to-manure-space-progress-dialog',
  templateUrl: './copy-cropfields-to-manure-space-progress-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CopyCropFieldsToManureSpaceProgressDialogComponent extends AbstractDialog<never> {
  readonly data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  protected readonly mdDialogRef =
    inject<
      MatDialogRef<
        CopyCropFieldsToManureSpaceProgressDialogComponent,
        AbstractDialogResultData<never>
      >
    >(MatDialogRef);
}
